import Cookies from 'js-cookie';

const CART_KEY = 'bailebelle_cart';

export const getCart = () => {
  if (typeof window === 'undefined') return { items: [], total: 0, count: 0 };
  const cart = Cookies.get(CART_KEY);
  const items = cart ? JSON.parse(cart) : [];
  const total = items.reduce((sum, item) => sum + (parseFloat(item.price || 0) * item.quantity), 0);
  const count = items.reduce((sum, item) => sum + item.quantity, 0);
  return { items, total, count };
};

export const setCart = (cart) => {
  if (typeof window === 'undefined') return;
  const items = Array.isArray(cart) ? cart : cart.items || [];
  Cookies.set(CART_KEY, JSON.stringify(items), { expires: 30 });
  window.dispatchEvent(new Event('cartUpdated'));
};

export const addToCart = (product, quantity = 1, variation = null) => {
  const cart = getCart();
  const items = [...cart.items];

  const existingItemIndex = items.findIndex(item =>
    item.id === product.id &&
    (variation ? item.variation_id === variation.id : !item.variation_id)
  );

  // Get the correct price - prioritize sale_price, then regular_price, then price
  const getProductPrice = (prod) => {
    if (prod.sale_price && prod.sale_price > 0) return parseFloat(prod.sale_price);
    if (prod.regular_price && prod.regular_price > 0) return parseFloat(prod.regular_price);
    if (prod.price && prod.price > 0) return parseFloat(prod.price);
    return 0;
  };

  const productPrice = variation ? getProductPrice(variation) : getProductPrice(product);

  if (existingItemIndex > -1) {
    items[existingItemIndex].quantity += quantity;
  } else {
    items.push({
      id: product.id,
      name: product.name,
      price: productPrice,
      regular_price: variation ? parseFloat(variation.regular_price || 0) : parseFloat(product.regular_price || 0),
      sale_price: variation ? parseFloat(variation.sale_price || 0) : parseFloat(product.sale_price || 0),
      image: variation && variation.image ? variation.image : (product.image || (product.images && product.images[0] ? product.images[0].src : 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5YTNhZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==')),
      quantity,
      variation_id: variation ? variation.id : null,
      attributes: variation ? variation.attributes : [],
      sku: variation ? variation.sku : product.sku,
      stock_quantity: variation ? variation.stock_quantity : product.stock_quantity,
    });
  }

  const total = items.reduce((sum, item) => sum + (parseFloat(item.price || 0) * item.quantity), 0);
  const count = items.reduce((sum, item) => sum + item.quantity, 0);
  const newCart = { items, total, count };

  setCart(newCart);
  return newCart;
};

export const removeFromCart = (productId, variationId = null) => {
  const cart = getCart();
  const items = cart.items.filter(item =>
    !(item.id === productId && (variationId ? item.variation_id === variationId : !item.variation_id))
  );

  const total = items.reduce((sum, item) => sum + (parseFloat(item.price || 0) * item.quantity), 0);
  const count = items.reduce((sum, item) => sum + item.quantity, 0);
  const newCart = { items, total, count };

  setCart(newCart);
  return newCart;
};

export const updateCartItemQuantity = (productId, newQuantity, variationId = null) => {
  const cart = getCart();
  const items = cart.items.map(item => {
    if (item.id === productId && (variationId ? item.variation_id === variationId : !item.variation_id)) {
      return { ...item, quantity: Math.max(1, newQuantity) };
    }
    return item;
  }).filter(item => item.quantity > 0); // Remove if quantity becomes 0

  const total = items.reduce((sum, item) => sum + (parseFloat(item.price || 0) * item.quantity), 0);
  const count = items.reduce((sum, item) => sum + item.quantity, 0);
  const newCart = { items, total, count };

  setCart(newCart);
  return newCart;
};

export const getCartItemCount = () => {
  const cart = getCart();
  return cart.count;
};


export const getCartTotal = () => {
  const cart = getCart();
  return cart.total;
};

export const clearCart = () => {
  setCart([]);
};

export const formatPrice = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};
